import React from 'react'

const Notification = (props) => (
  <>
    <span data-test-id="testing-patch-notification">
      {props.title || 'Testing your patch...'}
      <p className="uk-text-small">
        Your patch has been applied to the sandbox. We are testing your solution
        now.
      </p>
      {props.patchingTimes && props.patchingTimes[props.engine] ? (
        <div className="uk-text-small">
          {props.body || `Estimated time to test: ${(props.patchingTimes[props.engine] || 0) > 600 ? 600 : props.patchingTimes[props.engine]} seconds`}
        </div>
      ) : null}
    </span>
  </>
)
export default Notification
